var axios;
var Swiper;
var nanogallery2;
var WebSite;
(function (WebSite) {
    var AFWSwiper = (function () {
        function AFWSwiper(element, swiperSettings) {
            if (swiperSettings === void 0) { swiperSettings = null; }
            this.SwiperSettings = null;
            var swpSetJson = swiperSettings || element.getAttribute('data-swiper-settings');
            if (swpSetJson) {
                this.SwiperSettings = JSON.parse(swpSetJson);
            }
            new Swiper(element, this.SwiperSettings);
        }
        return AFWSwiper;
    }());
    WebSite.AFWSwiper = AFWSwiper;
    var Main = (function () {
        function Main() {
            this.pills = function () {
                var updateQueryString = function (tab) {
                    var url = new URL(String(window.location.href));
                    var urlParams = new URLSearchParams(url.search);
                    urlParams.set('tab', tab);
                    url.search = urlParams.toString();
                    window.history.replaceState({}, '', url.toString());
                };
                var urlParams = new URLSearchParams(window.location.search);
                var selectedTab = urlParams.get('tab');
                if (selectedTab) {
                    $("a.nav-link").removeClass("active");
                    $('#' + selectedTab).addClass("active");
                    $(".tab-pane").removeClass("show active");
                    $("#" + selectedTab + "-pane").addClass("show active");
                }
                $("#pills-tab a.nav-link").click(function (et) {
                    $("a.nav-link").removeClass("active");
                    var target = et.target;
                    $(target).addClass("active");
                    $(".tab-pane").removeClass("show active");
                    $("#" + target.id + "-pane").addClass("show active");
                    updateQueryString(target.id);
                });
            };
            this.collapsibleMenuClose = function () {
                $('.navbar-nav>li>a').on('click', function () {
                    $('.navbar-collapse').collapse('hide');
                });
            };
            this.homepageMainSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-homepageMainSwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    breakpoints: {
                        992: {
                            slidesPerView: 4,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        480: {
                            slidesPerView: 2,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-homepageMainSwiper-button-next',
                        prevEl: '.swiper-homepageMainSwiper-button-prev'
                    },
                });
            };
            this.gallerySwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-gallerySwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    centeredSlides: true,
                    loop: true,
                    loopAdditionalSlides: 2,
                    touchStartPreventDefault: false,
                    pagination: {
                        el: '.swiper-gallery-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pag " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    on: {
                        slideChange: function () {
                            var childNum = $(".swiper-gallery-pagination").children().length - 2;
                            var pagWidth = 360 / childNum;
                            $(".custom-pag").css("width", pagWidth + "px");
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 2,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-gallerySwiper-button-next',
                        prevEl: '.swiper-gallerySwiper-button-prev'
                    },
                });
                swiper.on("slideChange", function () {
                    $(".comments-block").removeClass("active");
                    $(".comments").find('[data-index="' + swiper.realIndex + '"]').addClass("active");
                });
            };
            this.bindSwiperTmpFunc = function () {
                var elements = document.querySelectorAll('[data-swiper-init]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    new WebSite.AFWSwiper(el);
                }
            };
            this.referencesSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-references-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    slideToClickedSlide: true,
                    touchStartPreventDefault: false,
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 2,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-references-button-next',
                        prevEl: '.swiper-references-button-prev'
                    },
                });
                swiper.on("slideChange", function () {
                    $(".comments-block").removeClass("active");
                    $(".comments").find('[data-index="' + swiper.realIndex + '"]').addClass("active");
                });
            };
            this.stickyNavigation = function () {
                var header = $("header");
                if ($(window).scrollTop() >= 1) {
                    header.addClass("sticky");
                }
                else {
                    header.removeClass("sticky");
                }
                $(window).scroll(function () {
                    if ($(window).scrollTop() >= 1) {
                        header.addClass("sticky");
                    }
                    else {
                        header.removeClass("sticky");
                    }
                });
            };
            this.mobileMenu = function () {
                var hamburger = $("#hamburger-menu");
                var mobileMenu = $("#mobile-menu");
                var header = $("header");
                var body = $("body");
                var buttonsMobileMenu = $(".mobile-menu-footer .btn");
                hamburger.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                    if (!header.hasClass("sticky")) {
                        header.addClass("sticky");
                    }
                });
                buttonsMobileMenu.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                });
            };
            this.collapseNavbarOnScroll = function () {
                document.getElementById("navbar").style.top = "0";
                var prevScrollpos = window.pageYOffset;
                window.onscroll = function () {
                    var currentScrollPos = window.pageYOffset;
                    if (prevScrollpos > currentScrollPos) {
                        document.getElementById("navbar").style.top = "0";
                    }
                    else {
                        document.getElementById("navbar").style.top = "-116px";
                    }
                    prevScrollpos = currentScrollPos;
                };
            };
            this.collapseShowMoreBtn = function () {
                $('.collapsed-agenda').on('shown.bs.collapse', function () {
                    $('.show-more-btn').text('Prikaži manj');
                });
                $('.collapsed-agenda').on('hidden.bs.collapse', function () {
                    $('html, body').animate({
                        scrollTop: $(".agenda-first").offset().top - 150
                    }, 500);
                    $('.show-more-btn').text('Prikaži celoten program');
                });
            };
            this.revealTextAnimation = function () {
                document.addEventListener('DOMContentLoaded', function () {
                    var paragraphs = Array.from(document.querySelectorAll(".faded-text"));
                    var spans = [];
                    paragraphs.forEach(function (paragraph) {
                        var htmlString = '';
                        var pArray = paragraph.textContent.split('');
                        for (var i = 0; i < pArray.length; i++) {
                            htmlString += "<span class=\"faded-text-spans\">" + pArray[i] + "</span>";
                        }
                        paragraph.innerHTML = htmlString;
                    });
                    spans = Array.from(document.querySelectorAll('.faded-text-spans'));
                    function revealSpans() {
                        for (var i = 0; i < spans.length; i++) {
                            if (spans[i].parentElement.getBoundingClientRect().top < window.innerHeight / 2) {
                                var _a = spans[i].getBoundingClientRect(), left = _a.left, top_1 = _a.top;
                                top_1 = top_1 - (window.innerHeight * .4);
                                var opacityValue = 1 - ((top_1 * .01) + (left * 0.001)) < 0.1 ? 0.1 : 1 - parseFloat(((top_1 * .01) + (left * 0.001)).toFixed(3));
                                opacityValue = opacityValue > 1 ? 1 : opacityValue;
                                spans[i].style.opacity = opacityValue.toString();
                            }
                        }
                    }
                    window.addEventListener('scroll', function () {
                        revealSpans();
                    });
                    revealSpans();
                });
            };
            this.rowSlideUpAnimation = function () {
                document.addEventListener('DOMContentLoaded', function () {
                    var rows = document.querySelectorAll('.slide-up-item');
                    var observer = new IntersectionObserver(handleIntersection, { threshold: 0.2 });
                    var delayedItemsCount = 0;
                    rows.forEach(function (row, index) {
                        observer.observe(row);
                        if (row.classList.contains('delayed')) {
                            if (delayedItemsCount >= 1) {
                                row.style.transitionDelay = (delayedItemsCount - 1) * 0.2 + 0.2 + "s";
                            }
                            delayedItemsCount++;
                        }
                        else {
                            row.style.transitionDelay = '0s';
                        }
                    });
                    function handleIntersection(entries, observer) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                entry.target.classList.add('slide-up-animation');
                            }
                            else {
                                entry.target.classList.remove('slide-up-animation');
                            }
                        });
                    }
                });
            };
            this.customSwipeCursor = function () {
                document.addEventListener('DOMContentLoaded', function () {
                    var customHoverElement = document.querySelector('.custom-hover-element');
                    var customCursor;
                    if (customHoverElement != null) {
                        customCursor = document.createElement('div');
                        var spanElement = document.createElement('span');
                        spanElement.innerHTML = 'SWIPE';
                        customCursor.classList.add('custom-cursor', 'd-none');
                        spanElement.classList.add('custom-cursor-span');
                        customCursor.appendChild(spanElement);
                        document.body.appendChild(customCursor);
                        if (customHoverElement) {
                            customHoverElement.addEventListener('mousemove', handleMouseMove);
                            customHoverElement.addEventListener('touchmove', handleTouchMove);
                            customHoverElement.addEventListener('mouseleave', handleMouseLeave);
                            customHoverElement.addEventListener('mouseenter', handleMouseEnter);
                        }
                    }
                    function handleMouseMove(event) {
                        updateCursorPosition(event.pageX, event.pageY);
                    }
                    function handleTouchMove(event) {
                        var touch = event.touches[0];
                        if (touch) {
                            updateCursorPosition(touch.pageX, touch.pageY);
                        }
                    }
                    function updateCursorPosition(x, y) {
                        customCursor.style.left = x - 25 + "px";
                        customCursor.style.top = y - 25 + "px";
                    }
                    function handleMouseLeave() {
                        document.body.style.cursor = 'default';
                        customCursor.style.opacity = '0';
                    }
                    function handleMouseEnter() {
                        document.body.style.cursor = 'none';
                        customCursor.classList.add('d-lg-block');
                        customCursor.offsetWidth;
                        customCursor.style.opacity = '1';
                    }
                });
            };
            this.dynamicTicketsForm = function () {
                var attendeesDiv = document.getElementById("attendees");
                var addButton = document.getElementById("addButton");
                var lastKnownCount = 0;
                function createInput(type, name, placeholder, required, colClass) {
                    if (required === void 0) { required = true; }
                    var inputDiv = document.createElement("div");
                    inputDiv.classList.add(colClass, "form-group");
                    var inputField = document.createElement("input");
                    inputField.type = type;
                    inputField.name = name;
                    inputField.placeholder = placeholder;
                    inputField.required = required;
                    inputDiv.appendChild(inputField);
                    if (required) {
                        inputDiv.classList.add("required");
                        var span = document.createElement("span");
                        span.innerHTML = "*";
                        span.classList.add("required-span");
                        inputDiv.appendChild(span);
                        console.log("span appended");
                    }
                    return inputDiv;
                }
                function removeRow(row) {
                    attendeesDiv.removeChild(row);
                    lastKnownCount--;
                    console.log(lastKnownCount);
                    updateButtonState();
                }
                function createAttendeeRow(i) {
                    var row = document.createElement("div");
                    row.classList.add("row", "attendee");
                    var namesInputField = createInput("text", "Names[" + i + "]", "Ime", true, "col-6");
                    var surnamesInputField = createInput("text", "Surnames[" + i + "]", "Priimek", true, "col-6");
                    var emailInputField = createInput("text", "EmailAddresses[" + i + "]", "Email", true, "col-6");
                    var phonesInputField = createInput("text", "Phones[" + i + "]", "Telefonska št.", false, "col-6");
                    var removeLink = document.createElement("a");
                    removeLink.href = "javascript:void(0);";
                    removeLink.textContent = "Odstrani";
                    removeLink.classList.add("btn-remove");
                    removeLink.addEventListener("click", function () { return removeRow(row); });
                    var hr = document.createElement("hr");
                    row.appendChild(namesInputField);
                    row.appendChild(surnamesInputField);
                    row.appendChild(emailInputField);
                    row.appendChild(phonesInputField);
                    row.appendChild(removeLink);
                    row.appendChild(hr);
                    return row;
                }
                function addAttendeeInputFields(count) {
                    if (attendeesDiv) {
                        while (attendeesDiv.children.length > count * 4) {
                            removeRow(attendeesDiv.lastChild);
                        }
                        if (lastKnownCount < 5) {
                            for (var i = lastKnownCount; i < count; i++) {
                                var row = createAttendeeRow(i);
                                attendeesDiv.appendChild(row);
                                console.log(lastKnownCount);
                            }
                        }
                        lastKnownCount = count;
                        updateButtonState();
                    }
                }
                function updateButtonState() {
                    if (addButton) {
                        if (lastKnownCount >= 5) {
                            addButton.classList.add("d-none");
                        }
                        else {
                            addButton.classList.remove("d-none");
                        }
                    }
                }
                if (addButton) {
                    addButton.addEventListener("click", function (event) {
                        event.preventDefault();
                        addAttendeeInputFields(lastKnownCount + 1);
                    });
                    updateButtonState();
                }
            };
            this.earlyBirdCountdown = function () {
                var countdownElement = document.getElementById('countdown');
                if (!countdownElement) {
                    return;
                }
                var targetDatetimeString = countdownElement.dataset.targetDatetime;
                if (!targetDatetimeString) {
                    console.error('Target datetime is missing.');
                    return;
                }
                var _a = targetDatetimeString.split(' '), datePart = _a[0], timePart = _a[1];
                var _b = datePart.split('-').map(Number), year = _b[0], month = _b[1], day = _b[2];
                var _c = timePart.split(':').map(Number), hours = _c[0], minutes = _c[1];
                var targetDatetime = new Date(year, month - 1, day, hours, minutes).getTime();
                if (isNaN(targetDatetime)) {
                    console.error('Invalid target datetime.');
                    return;
                }
                function padWithZero(number) {
                    return number < 10 ? "0" + number : "" + number;
                }
                updateCountdown();
                var intervalId = setInterval(updateCountdown, 1000);
                function updateCountdown() {
                    var currentDatetime = new Date().getTime();
                    var timeDifference = targetDatetime - currentDatetime;
                    var firstDivContent = countdownElement.children[0].outerHTML;
                    if (timeDifference <= 0) {
                        clearInterval(intervalId);
                        countdownElement.innerHTML = "\n                            " + firstDivContent + "\n                            <div class=\"col-2\"><span class=\"countdown-number\">00</span></div>\n                            <div class=\"col-2\"><span class=\"countdown-number\">00</span></div>\n                            <div class=\"col-2\"><span class=\"countdown-number\">00</span></div>\n                            <div class=\"col-2\"><span class=\"countdown-number\">00</span></div>";
                    }
                    else {
                        var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                        var hours_1 = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        var minutes_1 = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                        var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
                        countdownElement.innerHTML = "\n                            " + firstDivContent + "\n                            <div class=\"col-1 offset-0 col-2 offset-lg-0\"><span class=\"countdown-number\">" + padWithZero(days) + "</span></div>\n                            <div class=\"col-1 offset-1 col-2 offset-lg-0\"><span class=\"countdown-number\">" + padWithZero(hours_1) + "</span></div>\n                            <div class=\"col-1 offset-1 col-2 offset-lg-0\"><span class=\"countdown-number\">" + padWithZero(minutes_1) + "</span></div>\n                            <div class=\"col-1 offset-1 col-2 offset-lg-0\"><span class=\"countdown-number\">" + padWithZero(seconds) + "</span></div>";
                    }
                }
            };
            this.homepageMainSwiper();
            this.gallerySwiper();
            this.bindSwiperTmpFunc();
            this.referencesSwiper();
            this.collapseShowMoreBtn();
            this.stickyNavigation();
            this.mobileMenu();
            this.pills();
            this.revealTextAnimation();
            this.rowSlideUpAnimation();
            this.dynamicTicketsForm();
            this.earlyBirdCountdown();
            this.customSwipeCursor();
            this.collapsibleMenuClose();
        }
        return Main;
    }());
    WebSite.Main = Main;
})(WebSite || (WebSite = {}));
(function () {
    new WebSite.Main();
    var domainName = window.location.hostname;
    var cookieMain = $('.cookie');
    var cookieWarning = $(".cookie-dialog", cookieMain);
    $("#accept-cookies", cookieMain).on('click', function () {
        Cookies.set("analytic_consent", "1", { expires: 365, path: '/', domain: domainName });
        Cookies.set("analytic_consentNoPopUp", "1", { expires: 30, path: "/", domain: domainName });
        $('.cookie-dialog', cookieMain).fadeOut();
        window.location.reload();
    });
    var lastScrollTop = 0;
    $(window).on('scroll', function () {
        var el = $('.landing-shape');
        var currentBottomOffset = parseInt(el.css('bottom'));
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            el.css('bottom', currentBottomOffset + 5 + "px");
        }
        else {
            el.css('bottom', currentBottomOffset - 5 + "px");
        }
        lastScrollTop = st;
    });
    $('.mobile-dropdown-toggle').on('click', function () {
        $('.mobile-dropdown').toggleClass('show');
    });
    var childNum = $(".swiper-gallery-pagination").children().length - 2;
    var pagWidth = 360 / childNum;
    $(".custom-pag").css("width", pagWidth + "px");
})();
$(document).ready(function () {
    $('#frmBuyTicket').submit(function () {
        if ($(this).find('.input-validation-error').length == 0) {
            var btnSubmit = $('#btnSubmit');
            btnSubmit.val("Pošiljam ...");
            btnSubmit.prop('disabled', true);
        }
    });
    $('.third-button').on('click', function () {
        $('.animated-icon3').toggleClass('open');
        $('.mobile-navigation').toggleClass('hidden');
    });
    function getQueryParam(name) {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }
    var ParamValue = getQueryParam('formstatus');
    if (ParamValue == "success") {
        $('.success-content ').removeClass("d-none");
        $('.main-content').addClass("d-none");
    }
    var scrolLTopOnLoad = window.pageYOffset;
    $('.parallax-container .content').css('transform', 'translate3d(0, ' + -(scrolLTopOnLoad / 2) + 'px, 0)');
    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var scrolLTopOnLoad = window.pageYOffset;
        $('.parallax-container .content').css('transform', 'translate3d(0, ' + -(scrollTop / 2) + 'px, 0)');
    });
    history.scrollRestoration = "manual";
    $(window).on('beforeunload', function () {
        $(window).scrollTop(0);
    });
    $("#nanogallery2").nanogallery2({
        thumbnailHeight: 400,
        thumbnailWidth: "auto",
        galleryDisplayMode: 'fullContent',
        thumbnailLabel: { display: "false" },
        thumbnailBorderHorizontal: 0,
        thumbnailBorderVertical: 0,
        viewerTools: {
            topLeft: '',
            topRight: 'fullscreenButton, closeButton'
        },
    });
});
function closeNavigation() {
    $('.animated-icon3').toggleClass('open');
    var x = $(window).width();
    $('.navbar-collapse').toggleClass('show');
    $('.mobile-navigation').toggleClass('hidden');
}
function circleHover() {
    var element = $(".circle-animation");
    setTimeout(function () {
        element.addClass("second");
    }, 500);
}
;
function circleUnhover() {
    var element = $(".circle-animation");
    element.removeClass("second");
}
//# sourceMappingURL=Main.js.map